<template>
  <v-dialog v-model="visible" max-width="100%">
    <v-card style="overflow-y: hidden">
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <v-row dense>
          <v-col v-for="(item, indice) in listado" :key="indice" cols="12" md="4" lg="3" class="pa-0">
            <ListadoItem :nombreCampo="item.nombre" :valorCampo="item.valor" />
          </v-col>

          <v-col cols="12">
            <template v-if="permisosPresupuestos1 || permisosAcademicosNacional">
              <v-btn
                class="mx-1"
                color="primary"
                title="Registrar"
                small
                @click="$refs.modalFormularioPagosRef.abrir(accionesCrud.REGISTRAR, [])">
                <v-icon>mdi-plus</v-icon>

                Registrar
              </v-btn>

              <v-btn
                class="mx-1"
                title="Editar"
                small
                :disabled="item == null || item?.pagosUniversidades?.length > 0"
                @click="$refs.modalFormularioPagosRef.abrir(accionesCrud.EDITAR, item)">
                <v-icon>mdi-pencil</v-icon>

                Editar
              </v-btn>

              <v-btn
                small
                class="mx-1"
                :disabled="item == null || item?.pagosUniversidades?.length > 0"
                title="Eliminar"
                @click="
                  () =>
                    confirmacionAccion(
                      accionesAConfirmar.ELIMINAR,
                      nombreItem,
                      `de ${item.conceptoUniversidad.concepto.nombre} por ${item.monto}`,
                    )
                ">
                <v-icon>mdi-close</v-icon>

                Eliminar
              </v-btn>
            </template>

            <v-btn
              class="mx-1"
              title="Ver"
              small
              :disabled="item == null"
              @click="$refs.modalMostrarSolicitudPagosRef.abrir(item)">
              <v-icon>mdi-eye</v-icon>

              Ver
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver PDF"
              small
              :disabled="item == null || cargandoPdf"
              :loading="cargandoPdf"
              @click="obtenerReporteSolicitudPago(item.id)">
              <v-icon>mdi-file-pdf</v-icon>

              Ver PDF
            </v-btn>

            <v-btn
              class="mx-1"
              title="Ver Todos PDF"
              small
              :disabled="items.length === 0 || cargandoTodosPdf"
              :loading="cargandoTodosPdf"
              @click="obtenerReporteSolicitudesPagos">
              <v-icon>mdi-file-pdf</v-icon>

              Ver Todos PDF
            </v-btn>

            <v-btn class="mx-1" title="Recargar" small @click="listar">
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
          </v-col>

          <v-col cols="12">
            <ListadoSolicitudesPagos ref="listadoRef" :items="items" :cargando="cargando" @selectItem="selectItem" />
          </v-col>
        </v-row>

        <ModalFormularioSolicitudPago
          ref="modalFormularioPagosRef"
          :nombreRecurso="nombreItem"
          :programaUniversidadId="form?.id"
          @actualizarListado="listar" />

        <ModalMostrarSolicitudPago ref="modalMostrarSolicitudPagosRef" />

        <ModalVerPdf ref="modalVerPdfRef" />

        <ConfirmacionAccion
          ref="confirmacionRef"
          :titulo="confirmacion.titulo"
          :mensaje="confirmacion.mensaje"
          :realizandoAccion="confirmacion.realizandoAccion"
          @aceptar="confirmacion.fnAceptar" />
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar"> Cerrar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ListadoSolicitudesPagos from './ListadoSolicitudesPagos.vue';
import SolicitudPagoService from '../services/solicitud-pago.service';
import ModalFormularioSolicitudPago from './ModalFormularioSolicitudPago.vue';
import ModalMostrarSolicitudPago from './ModalMostrarSolicitudPago.vue';
import ModalVerPdf from './ModalVerPdf.vue';
import SolicitudPagoReporteService from '../services/solicitud-pago-reporte.service';
import { mapGetters } from 'vuex';
import programaUniversidadMixin from '../mixins/programa-universidad.mixin';

export default {
  name: 'ModalSolicitudesPagos',
  mixins: [programaUniversidadMixin],
  components: {
    ListadoSolicitudesPagos,
    ModalFormularioSolicitudPago,
    ModalMostrarSolicitudPago,
    ModalVerPdf,
  },
  data() {
    return {
      nombreItem: 'Solicitud Pago',
      cargandoPdf: false,
      cargandoTodosPdf: false,
    };
  },
  computed: {
    ...mapGetters({
      getFiltrarPorSede: 'pago/getFiltrarPorSede',
      permisosPresupuestos1: 'presupuesto/permisosPresupuestos1',
      permisosAcademicosNacional: 'pago/permisosAcademicosNacional',
    }),
  },
  methods: {
    abrir(accion, data = []) {
      this.abrirMixin(accion, data);
      this.listar();
    },
    listar() {
      const params = {
        programaUniversidadId: this.form.id,
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
      };

      this.obtenerDatosConNotificacion(SolicitudPagoService.findAll, 'items', this.nombreItem, params);

      this.item = null;
    },
    async getResponseAccion(accion) {
      let response = null;

      if (accion === this.accionesAConfirmar.ELIMINAR) {
        response = await SolicitudPagoService.remove(this.item.id);
      }

      return response;
    },
    async obtenerReporteSolicitudPago(solicitudId) {
      const params = {
        formato: 'base64',
      };

      this.cargandoPdf = true;

      try {
        const { data } = await SolicitudPagoReporteService.findOne(solicitudId, { params });
        const { datos, mensaje } = data;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoPdf = false;
      }
    },
    async obtenerReporteSolicitudesPagos() {
      const params = {
        formato: 'base64',
        sedeId: this.getFiltrarPorSede ? this.$store?.state?.cargo_sede?.sede?.id : null,
      };
      const programaUniversidadId = this.form.id;

      this.cargandoTodosPdf = true;

      try {
        const { data } = await SolicitudPagoReporteService.findAllPorProgramaUniversidadId(programaUniversidadId, {
          params,
        });
        const { datos, mensaje } = data;
        const base64 = datos;
        const pdf = `data:application/pdf;base64,${base64}`;

        this.$refs.modalVerPdfRef.abrir(pdf);
        this.$notify({
          group: 'notifications',
          title: this.nombreItem,
          text: mensaje || 'Listado exitoso',
          type: 'success',
        });
      } catch (error) {
        const { mensaje } = error?.response?.data;

        window.console.log(error);

        this.base64 = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener el reporte',
          type: 'error',
        });
      } finally {
        this.cargandoTodosPdf = false;
      }
    },
  },
};
</script>